// OGP OCCHIALI — Calcolo DI unico + semidistanze su email — Shopify-safe
document.addEventListener('DOMContentLoaded', function(){
  const CARD_WIDTH_MM = 85.60; // tessera ID-1

  // DOM refs
  const cv = document.getElementById('cv'), ctx = cv ? cv.getContext('2d') : null;
  const file = document.getElementById('file');
  const samePhotoBtn = document.getElementById('samePhotoBtn');
  const resetBtn = document.getElementById('reset');
  const undoBtn = document.getElementById('undoBtn');
  const output = document.getElementById('output');
  const consenso = document.getElementById('consensoDP');
  const fase = document.getElementById('fase');
  const status = document.getElementById('status');
  const hint = document.getElementById('hint');

  const postResult = document.getElementById('post-result');
  const semiBox = document.getElementById('semiBox');
  const semiText = document.getElementById('semiText');
  const emailInput = document.getElementById('emailInput');
  const emailBody = document.getElementById('emailBody');
  const copyBtn = document.getElementById('copyBtn');

  if (!cv || !ctx) { console.warn('OGP-DI: canvas mancante.'); return; }

  // Stato
  let img = new Image();
  let points = [];     // 0:L, 1:R, 2:cardL, 3:cardR, 4:nose
  let results = [];    // [{r,l}, {r,l}]
  let step = 1;
  let clicksEnabled = false;
  let finishingLock = false;

  // Utils
  const round05 = v => Math.round(v*2)/2;
  const format = v => round05(v).toFixed(1);
  const dist = (a,b) => Math.hypot(a.x-b.x, a.y-b.y);

  function updateFase(){
    if (fase) fase.innerHTML = `<b>Fase ${step} di 2</b> — Carica una foto e clicca i 5 punti nell’ordine indicato.`;
    updateStatus();
  }
  function updateStatus(){
    const needed = Math.max(0, 5 - points.length);
    if (status) status.textContent = img.src
      ? (needed>0 ? `Punti da inserire: ${needed}` : `Punti completati.`)
      : `Carica la foto ${step}.`;
    if (undoBtn) undoBtn.disabled = points.length===0;
    if (samePhotoBtn) samePhotoBtn.disabled = !(step===2 && img.src && points.length===0);
  }
  function setHint(msg=''){ if (hint) hint.textContent = msg; }

  function fit(){
    if (!img.width) return;
    const r = img.width / img.height;
    const w = Math.min(img.width, Math.min(window.innerWidth-40, 900));
    const h = Math.round(w / r);
    cv.width = w; cv.height = h;
    draw();
  }
  function draw(){
    ctx.clearRect(0,0,cv.width,cv.height);
    if (img.src) ctx.drawImage(img,0,0,cv.width,cv.height);
    const colors = ['#ff66ff','#00bcad','#ffec00','#ff7a00','#0091ff'];
    points.forEach((p,i)=>{
      ctx.beginPath();
      ctx.fillStyle = colors[i%colors.length];
      if (i === 2 || i === 3) {
        // QUADRATI per i bordi della tessera: più facile agganciare il bordo
        ctx.fillRect(p.x - 6, p.y - 6, 12, 12);
      } else {
        // CERCHI per pupille e naso
        ctx.arc(p.x,p.y,8,0,Math.PI*2); ctx.fill();
      }
      ctx.font='14px Arial'; ctx.fillStyle='#000';
      const labels=['1. Pupilla sx','2. Pupilla dx','3. Tessera sx','4. Tessera dx','5. Naso'];
      ctx.fillText(labels[i], p.x+10, p.y-10);
    });
  }

  function mmPerPx(){
    if (!(points[2] && points[3])) return null;
    return CARD_WIDTH_MM / dist(points[2], points[3]);
  }
  function computeCurrent(){
    const s = mmPerPx();
    if (!s || !(points[0] && points[1] && points[4])) return null;
    return {
      r:   dist(points[4],points[1]) * s,  // naso→OD
      l:   dist(points[4],points[0]) * s   // naso→OS
    };
  }

  // Testo per email/copia
  function buildSummary(DI, OD, OS){
    return `Distanza Interpupillare (DI): ${format(DI)} mm
Semidistanze: OD ${format(OD)} mm • OS ${format(OS)} mm

Consiglio: verifica la centratura quando ordini le lenti.`;
  }

  // Avviso range tipico
  function outlierMsg(di){
    // tipico adulti ~50–70 mm; casi rari ~45–80 mm
    if (di < 45 || di > 80) return 'Valore poco plausibile per un adulto (<45 o >80 mm).';
    if (di < 50 || di > 70) return 'Valore fuori dall’intervallo tipico (50–70 mm).';
    return '';
  }

  function finishStep(){
    const v = computeCurrent();
    if (!v) return;
    results.push(v);
    clicksEnabled = false;

    if (step === 1) {
      step = 2;
      setHint('Carica una seconda foto (consigliato) oppure usa la stessa foto per la 2ª misura.');
      if (file) file.value = '';
      points = []; draw(); updateFase(); clicksEnabled = true; updateStatus();
    } else {
      // Media tra due misure (precisione piena), poi arrotondo in output
      const avg = {
        r: (results[0].r + results[1].r) / 2,
        l: (results[0].l + results[1].l) / 2
      };
      const OD = round05(avg.r);
      const OS = round05(avg.l);
      const DI = round05(OD + OS);

      // Avviso su valori anomali
      const warn = outlierMsg(DI);
      if (warn) {
        const ok = confirm(`${warn}\nVuoi confermare questo risultato o ripetere la misurazione? OK = conferma, Annulla = rifai la 2ª foto.`);
        if (!ok) {
          step = 2; points = []; draw(); updateFase(); clicksEnabled = true; updateStatus();
          setHint('Ripeti la seconda misurazione per sicurezza.');
          return;
        }
      }

      // Mostra SUBITO solo DI
      output.innerHTML = `
        <div class="big" style="font-weight:700;font-size:1.2rem">Distanza Interpupillare (DI): ${format(DI)} mm</div>
        <div class="muted" style="color:#666">Vuoi ricevere anche le semidistanze (OD/OS) e i consigli? Inserisci la tua e-mail qui sotto.</div>
      `;

      // Prepara dati per email/copia
      const summary = buildSummary(DI, OD, OS);
      if (emailBody) emailBody.value = summary;

      // Mostra box email
      if (postResult) postResult.style.display = 'block';

      // Salva localmente per ripristino post-submit
      try {
        localStorage.setItem('ogp_di', JSON.stringify({DI, OD, OS}));
      } catch(e){}

      // Copia negli appunti
      copyBtn?.addEventListener('click', ()=>{
        try {
          navigator.clipboard?.writeText(summary);
          alert('Dati copiati negli appunti.');
        } catch(e){ alert('Copia non riuscita, prova lo screenshot.'); }
      }, { once:true });
    }
  }

  // Se torni dalla submit del form contact (con reCAPTCHA), mostra OD/OS salvati
  try {
    if (localStorage.getItem('ogp_show_semi') === '1') {
      const data = JSON.parse(localStorage.getItem('ogp_di') || '{}');
      if (data?.OD != null && data?.OS != null) {
        semiText.textContent = `OD: ${format(data.OD)} mm • OS: ${format(data.OS)} mm`;
        semiBox.style.display = 'block';
      }
      localStorage.removeItem('ogp_show_semi');
    }
  } catch(e){}

  // Eventi
  updateFase();

  file?.addEventListener('change', (e)=>{
    if (!consenso?.checked) { alert('Devi accettare il consenso privacy.'); file.value=''; return; }
    const f = e.target.files[0]; if (!f) return;
    const url = URL.createObjectURL(f);
    img = new Image();
    img.onload = ()=>{ points=[]; fit(); clicksEnabled=true; updateStatus(); setHint(''); };
    img.src = url;
  });

  cv?.addEventListener('click', (e)=>{
    if (!img.src || !clicksEnabled) return;
    if (points.length >= 5) return;
    const r = cv.getBoundingClientRect();
    const x = (e.clientX - r.left) * (cv.width / r.width);
    const y = (e.clientY - r.top)  * (cv.height / r.height);
    points.push({x,y}); draw(); updateStatus();
    if (points.length === 5) {
      if (finishingLock) return;
      finishingLock = true; clicksEnabled = false;
      setTimeout(()=>{ finishingLock = false; finishStep(); }, 0);
    }
  });

  undoBtn?.addEventListener('click', ()=>{ if(points.length){ points.pop(); draw(); updateStatus(); } });
  window.addEventListener('keydown', ev=>{ if(ev.key==='Backspace' && points.length){ ev.preventDefault(); points.pop(); draw(); updateStatus(); } });
  resetBtn?.addEventListener('click', ()=>{
    points=[]; results=[]; step=1; img=new Image();
    ctx.clearRect(0,0,cv.width,cv.height);
    clicksEnabled=false; if(file) file.value='';
    setHint(''); updateFase();
    output.innerHTML = '<div class="big" style="font-weight:700;font-size:1.2rem">Risultato finale: —</div><div class="muted" style="color:#666">Completa entrambe le foto per ottenere il risultato finale</div>';
    semiBox.style.display='none';
    postResult.style.display='none';
  });

  samePhotoBtn?.addEventListener('click', ()=>{
    if (!(step===2 && img.src)) return;
    points=[]; clicksEnabled=true; draw(); updateStatus();
    setHint('Stai ri-misurando sulla stessa foto. Meglio caricarne una diversa per maggiore affidabilità.');
  });

  window.addEventListener('resize', fit);
});
